import React from "react";
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <>
      <Typography variant="h3" component="h1" gutterBottom>
        Privacy Policy
      </Typography>

      <Container>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          <strong>Last Updated:</strong> March 27, 2025
        </Typography>

        <Typography paragraph>
          Trainer App ("we", "our", or "us") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, and
          safeguard your information when you use our app that enables coaches
          to send workouts to clients for logging and progress tracking.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Information We Collect
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Account information (name, email, password)" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Workout data (exercise logs, sets, reps, weights)" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Coach-client communication messages" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Usage analytics and device data" />
          </ListItem>
        </List>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          2. How We Use Your Information
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Provide and improve the app experience" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Facilitate communication between coaches and clients" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Monitor usage for analytics and performance" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Comply with legal obligations" />
          </ListItem>
        </List>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          3. Data Sharing
        </Typography>
        <Typography paragraph>
          We do not sell or rent your personal data. We may share data with
          third-party services only to the extent necessary to provide our app
          functionalities (e.g., secure cloud storage, authentication services).
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          4. Data Security
        </Typography>
        <Typography paragraph>
          We implement industry-standard measures to protect your data. However,
          no method of transmission over the internet is 100% secure.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          5. Your Rights
        </Typography>
        <Typography paragraph>
          You have the right to access, correct, or delete your data at any
          time. You may also contact us with any privacy-related concerns.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          6. Changes to This Policy
        </Typography>
        <Typography paragraph>
          We may update this policy from time to time. Any changes will be
          posted within the app and take effect immediately upon posting.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ marginTop: "1.5rem" }}>
          7. Contact Us
        </Typography>
        <Typography paragraph>
          If you have questions about this Privacy Policy, please contact us at
          info@trainerapp.com.
        </Typography>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
